import * as React from 'react';

import { Text } from '@components/common';
import { default as Select, SelectOption, SelectProps } from '@components/common/Select';
import { LockSVG, WorkspaceSVG } from '@components/svgs';

export const ROLE_OPTIONS: SelectOption<AccountRole>[] = [
  { value: 'admin', label: 'Admin only' },
  { value: 'creator', label: 'Admin & Creator only' },
  { value: 'observer', label: 'All roles' }
];

type Props = Omit<SelectProps<AccountRole>, 'options'>;

const renderOption = (v: (typeof ROLE_OPTIONS)[0]) => (
  <div className='flex items-center space-x-2 truncate'>
    {v.value === 'admin'}
    {v.value === 'creator'}
    {v.value === 'observer'}
    <Text h='400' truncate>
      {v.label}
    </Text>
  </div>
);

export const DefaultRoleSelect: React.FC<React.PropsWithChildren<Props>> = ({ ...rest }) => (
  <Select<AccountRole>
    {...rest}
    options={ROLE_OPTIONS}
    renderSelected={renderOption}
    renderLabel={renderOption}
    wrapperClass='w-full max-w-md'
  />
);
